module.exports = __webpack_public_path__ + "static/media/tag-delete.21f65fce.svg";